import ChatUserModel from "../models/chatUser";
import GenericProfilePhoto from "../../assets/images/tutor_base.jpg";
import { toTitleCase } from "../../utils/generalUtils";
import React, { useState } from "react";
import Swotbutton from "../../components/common/buttons/swotbutton";
import { ChatService } from "../services/chatService";

const ChatUserWidget = ({ user }: { user: ChatUserModel }) => {
  return (
    <div className="w-full flex flex-row justify-start items-center">
      <div className="w-12 h-12 min-w-12 m-2 rounded-full">
        <img
          className="w-auto rounded-sm  h-full"
          style={{ height: "90%", objectFit: "contain" }}
          src={(user.photoUrl && user.photoUrl != "null") ? user.photoUrl : GenericProfilePhoto}
          alt="userPhoto"
        />
      </div>
      <div className="flex flex-col pb-2 justify-start items-start overflow-hidden">
        <span className="text-md font-bold break-all">
          {toTitleCase(user.firstName)} {toTitleCase(user.lastName)}
        </span>

        {user.city && (
          <span className="text-md break-all">
            <span className="italic">from: </span> {user.city}
          </span>
        )}
      </div>
    </div>
  );
};

export default ChatUserWidget;
